import { MortgageRate, CreditScoreTier } from '../types';

export const RATES_LAST_UPDATED = 'Nov 14, 2025';

// These are simulated nationwide rates for owner-occupied single-family homes with excellent credit.
// As of Nov 14, 2025 for demonstration purposes.
export const baseRates: MortgageRate[] = [
  { type: '30-Year Fixed', term: 30, rate: 6.26 },
  { type: '20-Year Fixed', term: 20, rate: 6.01 },
  { type: '15-Year Fixed', term: 15, rate: 5.58 },
  { type: '10-Year Fixed', term: 10, rate: 5.60 },
];

// Approximate % points to add to the base rate based on credit score.
export const creditSpreads: Record<CreditScoreTier, number> = {
  [CreditScoreTier.EXCELLENT]: 0,
  [CreditScoreTier.GOOD]: 0.2,
  [CreditScoreTier.FAIR]: 0.5,
  [CreditScoreTier.POOR]: 1.0,
};